import { get } from 'helpers/api';
import merge from 'lodash/merge';
const rootPath = '/research/properties';

export function fetchProperty(id, params) {
  return get(`${rootPath}/${id}`, { params }).then(response => response.property);
}

export function searchProperties(searchTerm, params) {
  params = merge(params || {}, { 'q[name_or_address_cont]': searchTerm });

  return get(`${rootPath}.json`, { params }).then(response => response.properties);
}

export function searchAllProperties(searchTerm, params) {
  params = merge(params || {}, { all_databases: true });

  return searchProperties(searchTerm, params);
}
